export default class PreviousRegistration {
  registrationId?: number;
  registrationNumber?: string;

  constructor(regId: number | undefined, regNumber: string) {
    this.registrationId = regId;
    this.registrationNumber = regNumber;
  }
}
